class MessageQueue {
	constructor() {
		this.subscribers = {}; // Stores eventType -> [callbacks]
	}

	subscribe(eventType, callback) {
		if (!this.subscribers[eventType]) {
			this.subscribers[eventType] = [];
		}
		this.subscribers[eventType].push(callback);
	}

	unsubscribe(eventType, callback) {
		if (this.subscribers[eventType]) {
			this.subscribers[eventType] = this.subscribers[eventType].filter(
				(cb) => cb !== callback
			);
		}
	}

	publish(eventType, data) {
		if (this.subscribers[eventType]) {
			this.subscribers[eventType].forEach((callback) => {
				callback(data);
			});
		}
	}
}

export default MessageQueue;
